(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fede-collection-grid"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }
if (!customElements.get('fede-collection-grid')) {
  customElements.define('fede-collection-grid', class extends HTMLElement {
    connectedCallback() {
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.seen = new WeakSet();
      if (!('IntersectionObserver' in window)) return;
      this.reveals = new IntersectionObserver(entries => {
        const entering = entries.filter(entry => entry.isIntersecting);
        entering.forEach((entry, index) => {
          this.reveals.unobserve(entry.target);
          if (this.motion.matches) return;
          entry.target.animate([
            { opacity: .2, transform: 'translateY(16px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 350, delay: Math.min(index, 3) * 45, easing: 'ease-out', fill: 'backwards' });
        });
      }, { threshold: .08 });
      const scan = () => {
        this.querySelectorAll('.product-grid__item').forEach(card => {
          if (this.seen.has(card)) return;
          this.seen.add(card);
          this.reveals.observe(card);
        });
      };
      this.updates = new MutationObserver(() => {
        cancelAnimationFrame(this.scanFrame);
        this.scanFrame = requestAnimationFrame(scan);
      });
      this.updates.observe(this, { childList: true, subtree: true });
      this.onMotion = () => {
        if (this.motion.matches) this.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
      };
      this.motion.addEventListener('change', this.onMotion);
      scan();
    }
    disconnectedCallback() {
      this.updates?.disconnect();
      this.reveals?.disconnect();
      cancelAnimationFrame(this.scanFrame);
      this.motion?.removeEventListener('change', this.onMotion);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fede-sale"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fede-sale')) {
  customElements.define('fede-sale', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const grid = this.querySelector('.fede-sale__grid');
      const nav = this.querySelector('.fede-sale__brands');
      const pagination = this.querySelector('[data-sale-pagination]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const hero = this.querySelector('.fede-sale__hero-image');
      if (hero && 'IntersectionObserver' in window) {
        this.heroObserver = new IntersectionObserver(entries => {
          hero.classList.toggle('is-in-view', entries[0].isIntersecting);
        });
        this.heroObserver.observe(hero);
      }
      const animateCards = cards => {
        if (motion.matches) return;
        cards.forEach((card, index) => {
          card.getAnimations().forEach(animation => animation.cancel());
          card.animate([
            { opacity: 0, transform: 'translateY(28px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 400, delay: Math.min(index, 3) * 65, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
          const badge = card.querySelector('.fede-sale__badge');
          badge?.getAnimations().forEach(animation => animation.cancel());
          badge?.animate([
            { opacity: 0, transform: 'translateY(5px) scale(.96)' },
            { opacity: 1, transform: 'translateY(0) scale(1)' }
          ], { duration: 250, delay: Math.min(index, 3) * 65 + 100, easing: 'ease-out', fill: 'backwards' });
        });
      };
      this.onMotionChange = () => {
        if (motion.matches) {
          this.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
          this.observer?.disconnect();
        }
      };
      this.motion = motion;
      motion.addEventListener('change', this.onMotionChange);
      const reveal = () => {
        if (motion.matches || !('IntersectionObserver' in window)) return;
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          const entering = entries.filter(entry => entry.isIntersecting);
          animateCards(entering.map(entry => entry.target));
          entering.forEach(entry => this.observer.unobserve(entry.target));
        }, { threshold: 0.15, rootMargin: '0px 0px -24px 0px' });
        grid.querySelectorAll('[data-sale-card]:not([hidden])').forEach(card => this.observer.observe(card));
      };
      try {
        let next = pagination.querySelector('[data-sale-next]')?.href;
        const visited = new Set();
        while (next) {
          const url = new URL(next, location.href);
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Pagination unavailable');
          visited.add(url.href);
          url.searchParams.set('section_id', this.dataset.section);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Collection unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = doc.querySelector('fede-sale');
          if (!incoming) throw new Error('Collection unavailable');
          incoming.querySelectorAll('[data-sale-card]').forEach(card => grid.append(card));
          next = incoming.querySelector('[data-sale-next]')?.getAttribute('href');
        }
        pagination.hidden = true;
        const cards = [...grid.querySelectorAll('[data-sale-card]')];
        const choose = brand => {
          let count = 0;
          cards.forEach(card => {
            const vendor = card.dataset.vendor.trim();
            const title = card.dataset.title.trim();
            const matches = brand === 'all' || vendor === brand || title.startsWith(brand + ' ');
            card.hidden = !matches;
            card.getAnimations().forEach(animation => animation.cancel());
            if (matches) count++;
          });
          nav.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.brand === brand)));
          this.querySelector('[data-sale-count]').textContent = this.querySelector('[data-sale-count-template]').content.textContent.replace('__COUNT__', count);
          const counter = this.querySelector('[data-sale-count]');
          counter.getAnimations().forEach(animation => animation.cancel());
          if (!motion.matches) counter.animate([
            { opacity: .3, transform: 'translateY(3px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 250, easing: 'ease-out' });
          this.querySelector('[data-sale-empty]').hidden = count !== 0;
          reveal();
        };
        nav.addEventListener('click', event => {
          const button = event.target.closest('button[data-brand]');
          if (!button) return;
          choose(button.dataset.brand);
          button.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth', block: 'nearest', inline: 'nearest' });
        });
        nav.hidden = false;
        choose('all');
      } catch {
        this.querySelector('[data-sale-error]').hidden = false;
        reveal();
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.heroObserver?.disconnect();
      this.motion?.removeEventListener('change', this.onMotionChange);
      this.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
